import {
  useEffect,
  useState,
  memo,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../../Context/LanguageContext";
import standardAttributeStores from "../../../Stores/StandardAttributeStores";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import StandardAttribute_Actions from "../../../Actions/StandardAttribute_Actions";
import StandardAttributeConstants from "../../../Constants/StandardAttributeConstants";

const OverridePlantOptions = forwardRef((props, ref) => {
  const currentStandardAttrId = useRef(null);
  const [werkOptions, setWerkOptions] = useState([]);

  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  function getStandardAttrOptions() {
    if (currentStandardAttrId.current) {
      setGlobalSpinner(true);
      StandardAttribute_Actions.getOptions(currentStandardAttrId.current);
    }
  }

  useImperativeHandle(ref, () => ({
    handleLoadOptions(attrId) {
      currentStandardAttrId.current = attrId;
      getStandardAttrOptions();
    },
  }));

  useEffect(() => {
    function getOptionSuccess() {
      const res = standardAttributeStores.getAttributeOptions();
      if (res) {
        setWerkOptions(res.werkOptions);
      } else {
        setWerkOptions([]);
      }
      setGlobalSpinner(false);
    }

    function getOptionFailure() {
      setGlobalSpinner(false);
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_ATTRIBUTE_OPTIONS_SUCCESS,
      getOptionSuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_ATTRIBUTE_OPTIONS_FAILURE,
      getOptionFailure,
    );

    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_ATTRIBUTE_OPTIONS_SUCCESS,
        getOptionSuccess,
      );

      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_ATTRIBUTE_OPTIONS_FAILURE,
        getOptionFailure,
      );
    };
  }, []);

  function overridePlantOptionsFormSubmit() {
    let attributeData = {
      StandardattributvorlageId: currentStandardAttrId.current,
      WerkOptions: werkOptions,
    };
    setGlobalSpinner(true);
    StandardAttribute_Actions.SaveUpdateWerkAttributeOptions(attributeData);
  }

  useEffect(() => {
    function SaveUpdateWerkAttributeOptionSuccess() {
      const res = standardAttributeStores.getSaveUpdateWerkOptionsRes();
      if (res) {
        toast.success(localization.optionsSavedSuccess);
      }
      setGlobalSpinner(false);
    }

    function SaveUpdateWerkAttributeOptionFailure() {
      const res = standardAttributeStores.getSaveUpdateWerkOptionsRes();
      toast.error(res);
      setGlobalSpinner(false);
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_SUCCESS,
      SaveUpdateWerkAttributeOptionSuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_FAILURE,
      SaveUpdateWerkAttributeOptionFailure,
    );

    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_SUCCESS,
        SaveUpdateWerkAttributeOptionSuccess,
      );

      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.SAVE_UPDATE_WERK_ATTRIBUTE_OPTIONS_FAILURE,
        SaveUpdateWerkAttributeOptionFailure,
      );
    };
  }, []);

  const handleOnChange = (e, index) => {
    let localWerkOptions = [...werkOptions];
    localWerkOptions[index].options =
      e.target.value == "" ? null : e.target.value;
    setWerkOptions(localWerkOptions);
  };

  function handleClosePopOver() {}

  return (
    <div
      className="modal fade"
      id="overridePlantOptionsModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="overridePlantOptionsModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="custom-modal-medium modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="overridePlantOptionsModalTitle">
              {localization.overwritePlantOptions}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="overridePlantOptionsModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <form id="overridePlantOptionsForm" name="overridePlantOptionsForm">
              <div className="table-responsive px-3 overwritePlantTableList">
                <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                  <thead className="bg-light">
                    <tr>
                      <th>{localization.plantName}</th>
                      <th>{localization.options}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {werkOptions.length == 0 ? (
                      <tr>
                        <td className="text-center" colSpan={100}>
                          <p>{localization.noRecordFound}</p>
                        </td>
                      </tr>
                    ) : (
                      werkOptions.map((row, index) => {
                        return (
                          <tr key={index}>
                            <td>{row.werk}</td>
                            <td>
                              <textarea
                                rows={5}
                                cols={125}
                                placeholder={localization.enterOptionsLike}
                                onChange={(e) => {
                                  handleOnChange(e, index);
                                }}
                                value={row.options != null ? row.options : ""}
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <div className="form-group marProp">
              <button
                type="button"
                className="btn btn-primary mb-4"
                onClick={overridePlantOptionsFormSubmit}
              >
                {localization.save}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default memo(OverridePlantOptions);
